/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/component-selector */
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewChecked,
  OnChanges,
} from '@angular/core';
import {
  CustomerModel,
  StockSaleSummaryFilterModel,
  LocationModel,
  LocationFilterModel,
  KanziActions,
  StockSaleSummaryListModel,
  StockSaleSummaryModel,
} from '@kanzi-apes/kanzi-models';
import moment from 'moment';
import { FeatureCollectionModel } from '../../models/floormap.models';
import { LocationListService } from '@kanzi-apes/kanzi-locations';
import { KanziSalesFloormapChartService } from '../../services';
import { KanziRestClientService } from '@kanzi-apes/kanzi-rest-api';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import * as fromAuth from '@kanzi-apes/kanzi-auth';
import {
  FURNISHINGS,
  FloormapViewerComponent,
} from '@kanzi-apes/kanzi-floormap-ui';
import { Store } from '@ngrx/store';
import { AutoCompleteSelectEvent } from 'primeng/autocomplete';

@Component({
    selector: 'lib-kanzi-sales-floormap-chart',
    templateUrl: './kanzi-sales-floormap-chart.component.html',
    styleUrls: ['./kanzi-sales-floormap-chart.component.scss'],
    standalone: false
})
export class KanziSalesFloormapChartComponent implements OnInit {
  // @ViewChild(DxVectorMapComponent, { static: true })
  // chart!: DxVectorMapComponent;
  @Input() customer!: CustomerModel | null;

  @ViewChild(FloormapViewerComponent)
  floormapViewerComponent!: FloormapViewerComponent;
  private queryLocations: string | null = null;
  private kongUrl = this.envService.environment?.kongApi;
  private salesTotalsUrl = `${this.kongUrl}${this.envService.environment?.apiModules.inventory}moves/type-totals-by-location/`;

  filters!: StockSaleSummaryFilterModel;
  rangeDates: Date[] = [];
  filteredLocations: LocationModel[] = [];
  projection: any;
  roomsData: { object: any; type: string }[] = [];
  storeSelected!: LocationModel | null;
  showRoomSelected!: LocationModel | null;
  dataGroupFurniture: { object: any; type: string }[] = [];
  pendingList = false;
  reportTypeAmount: { name: string; value: string }[] = [];
  isDisabledFilters = false;

  dataReport: {
    showRoomSelected: LocationModel;
    dataGroupFurniture: { object: any; type: string }[];
  } | null = null;

  constructor(
    private locationService: LocationListService,
    private apiClientService: KanziRestClientService,
    private envService: EnvironmentService,
    private floormapChartService: KanziSalesFloormapChartService,
    private storeAuth: Store<fromAuth.AuthState>
  ) {}

  ngOnInit(): void {
    this.reportTypeAmount = [
      { name: 'QTY', value: 'AMOUNT' },
      { name: 'AMOUNT', value: 'PRICE' },
    ];

    this.storeAuth.select(fromAuth.getAuthUser).subscribe((user) => {
      if (user) {
        this.queryLocations =
          user && user.configs
            ? user.configs?.audit_locations.map((item) => item.name).toString()
            : null;
      }
    });
  }

  selectDateRange(range: Date[]) {
    if (range[1]) {
      const initDate = moment(range[0]).format('MM/DD/YYYY');
      const endDate = moment(range[1]).format('MM/DD/YYYY');
      // endDate = moment(endDate).add(1, 'day').format('MM/DD/YYYY');
      // if (initDate == endDate) {
      // }
      this.filters = {
        ...this.filters,
        created_min: initDate,
        created_max: endDate,
        page: 1,
        page_size: 100,
        parent_id: this.showRoomSelected?.id,
        customer_id: this.customer?.id,
        is_active: true,
        type: `${KanziActions.SALE_OUT},${KanziActions.RETURN}`,
      };
      this.dataGroupFurniture = [];
      this.salesMapData(this.filters);
    }
  }

  selectAmountType(option: { value: { name: string; value: string } }) {
    if (option) {
      this.filters = { ...this.filters, amount_type: option.value.value };
      this.dataGroupFurniture = [];
      this.salesMapData(this.filters);
    }
  }
  salesMapData(filters?: StockSaleSummaryFilterModel) {
    if (filters) {
      this.pendingList = true;
      this.apiClientService
        .get<StockSaleSummaryListModel>(
          this.salesTotalsUrl,
          filters,
          'Error al traer el resumen de las ventas.'
        )
        .subscribe((list) => {
          if (list && list.count > 0) {
            this.createReportFromSublocationsSales(list.results);
          }
          this.pendingList = false;
          this.isDisabledFilters = true;
        });
    }
  }

  clearFilters() {
    //this.initTreeMapData();
    this.dataReport = null;
    this.storeSelected = null;
    this.showRoomSelected = null;
    this.rangeDates = [];
    this.isDisabledFilters = false;
    this.floormapViewerComponent.clearLayout();
  }

  customizeTooltip(arg: any) {
    if (arg.layer.name === 'rooms')
      return {
        text: 'Ventas: ' + arg.attribute('square') + ' %',
      } as any;
  }

  getBuildingData() {
    let buildingData: FeatureCollectionModel;

    return buildingData!;
  }

  onSelectStore(store: AutoCompleteSelectEvent) {
    if (store) {
      this.storeSelected = store.value;
    }
  }

  onSelectShowRoom(store: AutoCompleteSelectEvent) {
    if (store) {
      this.showRoomSelected = store.value;
    }
  }

  filterLocations(
    event: any,
    storeType: any,
    parent: LocationModel | null = null
  ) {
    const query = event.query;

    let filter: LocationFilterModel = {
      page: 1,
      page_size: 1000,
      type__name: storeType,
      customer_id: this.customer ? this.customer.id : null,
      search: query,
    };
    if (parent) {
      filter = {
        ...filter,
        parent_id: parent.id,
      };
    }

    // if (this.queryLocations) {
    //   filter = {
    //     ...filter,
    //     names__location: this.queryLocations,
    //   };
    // }
    return this.locationService
      .getlocationList(filter)
      .subscribe((locations) => (this.filteredLocations = locations.results));
  }

  createReportFromSublocationsSales(saleSummaries: StockSaleSummaryModel[]) {
    let totalPercentageSale = 0;
    let topLimitPercentageSale = 0;
    const salesLength = saleSummaries.length;
    saleSummaries.forEach((sales) => {
      totalPercentageSale += sales.percentage;
      if (sales.percentage > topLimitPercentageSale) {
        topLimitPercentageSale = sales.percentage;
      }
    });
    const dataGroupFurniture = saleSummaries
      .map((summ) => {
        if (summ.sub_location && summ.sub_location.properties) {
          return {
            title: summ.sub_location.properties.type,
            top: summ.sub_location.params
              ? summ.sub_location.params.map_point
                ? summ.sub_location.params.map_point.y_position
                : 0
              : 0,
            left: summ.sub_location.params
              ? summ.sub_location.params.map_point
                ? summ.sub_location.params.map_point.x_position
                : 0
              : 0,
            name: summ.sub_location.display_name,
            value: summ.percentage,
          };
        } else {
          return null;
        }
      })
      .map((locN) => {
        if (locN) {
          const fs = FURNISHINGS.filter((fur: any) => fur.title === locN.title);
          if (!fs[0]) {
            return null;
          }
          const result = {
            ...fs[0],
            top: locN.top,
            left: locN.left,
            parts: [].concat(
              this.addValueDataToFurniture(fs[0].parts, locN.name, locN.value)
            ),
            backgroundColor: this.floormapChartService.colorForPercentage(
              locN.value,
              totalPercentageSale / salesLength,
              topLimitPercentageSale
            ),
          };
          return result;
        }
        return locN;
      })
      .filter((data) => data !== null)
      .map((gr) => {
        return {
          type: 'FURNITURE',
          object: gr,
        };
      });

    this.dataReport = {
      showRoomSelected: this.showRoomSelected as LocationModel,
      dataGroupFurniture,
    };
  }

  addValueDataToFurniture(parts: any[], name: string, value: number): any {
    return parts.map((part) => {
      if (part.type === 'text') {
        if (part.definition.name === 'TEXT:name') {
          return { ...part, definition: { ...part.definition, text: name } };
        } else if (part.definition.name === 'TEXT:value') {
          return {
            ...part,
            definition: { ...part.definition, text: `${value}%` },
          };
        }
      }
      return part;
    });
  }
}
